import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { FormProvider, useForm } from "react-hook-form"
import { UFInput } from "../../../components/Common/Fields/Input"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchHrmsPayroll,
  fetchPayrollEdit,
  postHrmsPayroll,
  updatePayrollStatus,
} from "../../../services/Hrms/hrms"
import HrmsSearch from "../search"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"
import { useLocation } from "react-router-dom"

const schema = yup.object().shape({
  name: yup.string().required("Payroll is Required"),
  account_group_id: yup.mixed().required("Group id is Required"),
})
const Payroll = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Payrolls${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      name: "",
      account_group_id: null
    },
  })
  const [isLoading, setIsLoading] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")

  const [payrollList, setPayroll] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [editPayroll, setEditPayroll] = useState("")
  const [deductionCheck, setDeductionCheck] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  console.log(" deductionCheck :", deductionCheck)
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchHrmsPayroll({
        params: `${search ? `&searchText=${search}` : "&searchText"}${page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setPayroll(response)
      const newData = response?.data?.data || [];

      setPayroll(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, search, page, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < payrollList?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [payrollList, page]);

  useEffect(() => {
    if (editPayroll.id) {
      reset({
        ...editPayroll, account_group_id: {
          label: editPayroll?.account_group_id?.name,
          value: editPayroll?.account_group_id?.value
        }
      })
      setDeductionCheck(editPayroll?.is_deduction == "1" ? true : false)
    }
  }, [editPayroll.id])

  const handlePayroll = async data => {
    console.log("group_id", data)

    try {
      setIsLoading(true)
      const createdSeries = await postHrmsPayroll({
        ...data,
        is_deduction: deductionCheck ? 1 : 0,
        account_group_id: data?.account_group_id?.value
      })
      toastSuccess(createdSeries?.message)
      reset({
        name: "",
        account_group_id: {
          value: null,
          label: null,
        },
        is_deduction: false,
      })
      setDeductionCheck(false)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setEditPayroll("")
    }
  }

  const handleEdit = async item => {
    const response = await fetchPayrollEdit(item)
    setEditPayroll(response?.data)
    console.log("ed", response?.data)
  }

  const handleStatus = async id => {
    try {
      const response = await updatePayrollStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Payroll",
      renderCell: item => <div className="capitalize-letter">{item?.name}</div>,
      sortKey: "name",
    },
    {
      label: "Is Deduction",
      renderCell: item => (item?.is_deduction == 0 ? "Benefit" : "Deduction"),
      sortKey: "is_deduction",
    },
    {
      label: "Group Type",
      renderCell: item => <div className="capitalize-letter">{item?.account_group?.name ? item?.account_group?.name : "-"}</div>,
      sortKey: "name",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status == 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status == 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              <>
                {item?.status == 1 && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item?.id)}
                  >
                    Edit
                  </div>
                )}
                <div
                  className={`${item?.status == 1 ? "popover-border" : ""
                    } table-popup-content`}
                  onClick={() => handleStatus(item?.id)}
                >
                  {item?.status == 1 ? "Deactivate" : "Activate"}
                </div>
              </>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCancel = () => {
    reset({
      name: "",
      account_group_id: {
        label: null,
        value: null,
      }
    })
    setEditPayroll("")
    setDeductionCheck(false)
  }

  const handleDeductionCheck = dt => {
    setDeductionCheck(!dt)
  }

  // const onSelectChange = dt => {
  //   setData(dt.value)
  //   console.log("value", dt.value)
  // }
  // console.log("data", data)

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="HRMS"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: crumb || "Masters", link: "/hrms" },
                { title: "Payrolls", link: "/hrms-payroll" },
              ]}
            />
          </div>

          <Row className="mt-2">
            <Col xs={5}>
              <Card className="me-2 px-2 pb-2 input-card">
                <div className="input-card-head edittheamtitle">
                  {editPayroll?.id ? "Edit" : "Add"}
                </div>
                <hr className="table-divide" />
                <FormProvider {...methods}>
                  <Form id={`ev-form`} onSubmit={handleSubmit(handlePayroll)}>
                    <Row className="mt-2">
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>
                            Payroll<span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter the payroll"
                            name={"name"}
                            invalid={!!errors.name}
                          />
                          <FormFeedback invalid>
                            {errors.name?.message}
                          </FormFeedback>
                        </FormGroup>
                        <Col
                          lg={"auto"}
                        >
                          <FormGroup>
                            <input
                              onClick={() => handleDeductionCheck(deductionCheck)}
                              type="checkbox"
                              className="ever-rise-checkbox"
                              name={"is_deduction"}
                              checked={deductionCheck}
                            />
                            <Label className="ms-2">Is Deduction</Label>
                          </FormGroup>
                        </Col>
                        <FormGroup className="mb-4">
                          <Label>
                            Group Type<span className="mandatory">*</span>
                          </Label>
                          <FinanceGroupType
                            control={control}
                            placeholder="Select the Group Type"
                            name={"account_group_id"}
                            // clearable={true}
                            invalid={!!errors.account_group_id}
                          // parentChk={true}
                          />
                          <FormFeedback invalid>
                            {errors.account_group_id?.message}
                          </FormFeedback>
                        </FormGroup>

                        <div className="float-end">
                          <Button
                            className="btn-secondary me-2"
                            form={`ev-form`}
                            color={"secondary"}
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            form={`ev-form`}
                            color={"primary"}
                            loading={isLoading}
                            disabled={isLoading}
                            type="submit"
                          >
                            {editPayroll?.id ? "Update" : "Create"}
                          </LoadingButton>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </FormProvider>
              </Card>
            </Col>
            <Col xs={7}>
              <Card className="me-2 px-2 pb-2">
                <HrmsSearch
                  handleSearchChange={handleSearchChange}
                  placeholder="Payroll"
                />
                <hr className="table-divide" />
                <Row className="mt-2 ever-rise-table">
                  <Col xs={12}>
                  <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                    {payrollList?.data?.data && (
                      <UpdateTable
                        className="mt-5"
                        nodes={payrollList?.data?.data}
                        paginate={payrollList?.data}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleSizePerPage={handleSizePerPageChange}
                        tableWidth="32% 20% 18% 15% 15%"
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                        position={true}
                      />
                    )}
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Payroll
